import React, { useCallback } from 'react';
import FormattedMessage from 'react-intl/lib/components/message';
import { render } from 'preact';
import { Button, Grid, Dialog } from '@ori-ui/material-ui';
import * as LoyaltyDialogResult from '@ori-events/loyalty-dialog-result';
import { rootEl } from './app_loader';
import DialogHeader from './components/DialogHeader';
import DialogContent from './components/DialogContent';
import { OriContext } from './AppRender';
import Formatter from '@ori/formatter';
const App = (data) => {
    const oriContext = React.useContext(OriContext);
    const formatter = new Formatter(oriContext.oriCurrency);
    const handleLoyaltyDialogResult = useCallback((result) => {
        const event = new CustomEvent(LoyaltyDialogResult.Name, {
            detail: Object.assign(Object.assign({}, data), { result }),
        });
        window.dispatchEvent(event);
        // unmountDialog
        if (rootEl) {
            render(null, rootEl);
        }
    }, [data]);
    return (React.createElement(Dialog, { onClose: () => handleLoyaltyDialogResult(LoyaltyDialogResult.Result.CLOSE), maxWidth: "xs", fullWidth: true, open: true },
        React.createElement(DialogHeader, { points: data.loyaltyPoints }),
        React.createElement(DialogContent, { actions: React.createElement(Grid, { container: true, direction: "column", spacing: 3 },
                React.createElement(Grid, { item: true },
                    React.createElement(Button, { variant: "contained", color: "primary", fullWidth: true, onClick: () => handleLoyaltyDialogResult(LoyaltyDialogResult.Result.BUY_FOR_POINTS) },
                        React.createElement(FormattedMessage, { id: "_0P", values: {
                                0: data.loyaltyPoints,
                            } }),
                        (data === null || data === void 0 ? void 0 : data.loyaltyPrice) !== 0 && (React.createElement(FormattedMessage, { id: "loyaltyPrice", values: {
                                0: formatter.formatCurrency(data.loyaltyPrice || 0),
                            } })))),
                React.createElement(Grid, { item: true },
                    React.createElement(Button, { variant: "outlined", color: "primary", fullWidth: true, onClick: () => handleLoyaltyDialogResult(LoyaltyDialogResult.Result.BUY_FOR_MONEY) }, formatter.formatCurrency(data.consultantPrice || 0)))) })));
};
export default App;
